import Route from '@ember/routing/route';

export default class InsightsRoute extends Route {}
